export const views = {
  advertiserList: {
    title: 'Advertiser List',
  },
}
